/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Weight_Unit_LbInputs */

const en_us2_profile_weight_unit_lb = /** @type {(inputs: Profile_Weight_Unit_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pounds (lb)`)
};

const pt_br2_profile_weight_unit_lb = /** @type {(inputs: Profile_Weight_Unit_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libras (lb)`)
};

const es_419_profile_weight_unit_lb = /** @type {(inputs: Profile_Weight_Unit_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libras (lb)`)
};

const pt_pt2_profile_weight_unit_lb = /** @type {(inputs: Profile_Weight_Unit_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libras (lb)`)
};

const fr_fr2_profile_weight_unit_lb = /** @type {(inputs: Profile_Weight_Unit_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livres (lb)`)
};

const de_de2_profile_weight_unit_lb = /** @type {(inputs: Profile_Weight_Unit_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pfund (lb)`)
};

const it_it2_profile_weight_unit_lb = /** @type {(inputs: Profile_Weight_Unit_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libbre (lb)`)
};

/**
* | output |
* | --- |
* | "Pounds (lb)" |
*
* @param {Profile_Weight_Unit_LbInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_weight_unit_lb = /** @type {((inputs?: Profile_Weight_Unit_LbInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Weight_Unit_LbInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_weight_unit_lb(inputs)
	if (locale === "es-419") return es_419_profile_weight_unit_lb(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_weight_unit_lb(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_weight_unit_lb(inputs)
	if (locale === "de-DE") return de_de2_profile_weight_unit_lb(inputs)
	if (locale === "it-IT") return it_it2_profile_weight_unit_lb(inputs)
	return en_us2_profile_weight_unit_lb(inputs)
});
export { profile_weight_unit_lb as "profile.weight_unit_lb" }